import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
Vue.use(VueRouter);
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      keepAlive: false, //true是保存缓存，false是不保存
    },
  },
  {
    path: "/Home",
    component: Home,
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: "/",
        name: "main",
        component: () => import("../views/Main/main.vue"),
      },
      {
        path: "/order",
        name: "order",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shouye/order.vue"),
      },
      {
        path: "/logisticsTimelinessTable",
        name: "logisticsTimelinessTable",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shouye/logisticsTimelinessTable.vue"),
      },
      {
        path: "/payoff",
        name: "payoff",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shouye/payoff.vue"),
      },
      {
        path: "/production",
        name: "production",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/production-order.vue"),
      },
      {
        path: "/treasury",
        name: "treasury",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/treasury-plan.vue"),
      },
      {
        path: "/warning",
        name: "warning",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/warning.vue"),
      },
      {
        path: "/hardwareWaybil",
        name: "hardwareWaybil",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/hardwareWaybil.vue"),
      },
      {
        path: "/waybil",
        name: "waybil",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/waybil.vue"),
      },
      {
        path: "/deliver",
        name: "deliver",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/deliver"),
      },
      {
        path: "/deliver/twentyfive",
        name: "twentyfive",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/printView/twentyfive"),
      },
      {
        path: "/waybil/establish",
        name: "establish",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/establish"),
      },
      {
        path: "/ziti",
        name: "ziti",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/ziti.vue"),
      },
      {
        path: "/stock",
        name: "stock",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shengchan/stock.vue"),
      },
      {
        path: "/ginventory",
        name: "ginventory",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Ganxian/artery-inventory.vue"),
      },
      {
        path: "/gplan",
        name: "gplan",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Ganxian/artery-plan.vue"),
      },
      {
        path: "/gwaybill",
        name: "gwaybill",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Ganxian/artery-waybill.vue"),
      },
      {
        path: "/gwaybill/createwaybill",
        name: "createwaybill",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/createwaybill"),
      },
      {
        path: "/artery",
        name: "artery",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Ganxian/artery.vue"),
      },
      {
        path: "/zinventory",
        name: "zinventory",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Zhixian/branch-inventory.vue"),
      },
      {
        path: "/zplan",
        name: "zplan",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Zhixian/branch-plan.vue"),
      },
      {
        path: "/zwaybill",
        name: "zwaybill",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Zhixian/branch-waybill.vue"),
      },
      {
        path: "/zwaybill/trunkwaybill",
        name: "trunkwaybill",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/trunkwaybill"),
      },
      {
        path: "/branch",
        name: "branch",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Zhixian/branch.vue"),
      },
      {
        path: "/account",
        name: "account",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/account.vue"),
      },
      {
        path: "/authority",
        name: "authority",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/authority.vue"),
      },
      {
        path: "/city",
        name: "city",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/city"),
      },
      {
        path: "basic",
        name: "basic",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/basic"),
      },
      {
        path: "/role",
        name: "role",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/role.vue"),
      },
      {
        path: "/role/jurisdiction",
        name: "jurisdiction",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/jurisdiction.vue"),
      },
      {
        path: "/role/addRole",
        name: "addRole",
        meta: {
          keepAlive: true,
        },
        component: () => import("../components/addRole.vue"),
      },
      {
        path: "/user",
        name: "user",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/user.vue"),
      },
      {
        path: "/carriage",
        name: "carriage",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Xitong/carriage"),
      },
      {
        path: "/inquiry",
        name: "inquiry",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Dingdan/inquiry.vue"),
      },
      //工程发货单
      {
        path: "/project",
        name: "project",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Project/project.vue"),
      },
      //详情页面
      {
        path: "/particulars",
        name: "particulars",
        meta: {
          keepAlive: false,
        },
        component: () => import("../views/Particulars/particulars.vue"),
      },
      //生产厂订单报表
      {
        path: "/factory",
        name: "factory",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Factory/factory.vue"),
      },
      // 加急清单
      {
        path: "/urgentList",
        name: "urgentList",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Urgent/urgentList.vue"),
      },
      //干线物流订单报表
      {
        path: "/logisticsBase",
        name: "logisticsBase",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/LogisticsBase/logisticsBase.vue"),
      },
      //支线物流订单报表
      {
        path: "/logisticsReport",
        name: "logisticsReport",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/LogisticsReport/logisticsReport.vue"),
      },
      //干线物流管理
      {
        path: "/gtreasuryplan",
        name: "gtreasuryplan",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Gtreasuryplan/gtreasuryplan.vue"),
      },
      //干线城市退回
      {
        path: "/trunkCityback",
        name: "trunkCityback",
        meta: {
          keepAlive: false,
        },
        component: () => import("../views/Ganxian/trunkCityback.vue"),
      },
      //支线城市退回
      {
        path: "/branchCityback",
        name: "branchCityback",
        meta: {
          keepAlive: false,
        },
        component: () => import("../views/Zhixian/branchCityback.vue"),
      },
      //发货清单（25厂）
      {
        path: "/shippinglist",
        name: "shippinglist",
        meta: {
          keepAlive: false,
        },
        component: () => import("../views/Shengchan/shippinglist.vue"),
      },
      //干线货到城市
      {
        path: "/trunkdelivery",
        name: "trunkdelivery",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Ganxian/trunkdelivery.vue"),
      },
      //支线货到城市
      {
        path: "/branchdelivery",
        name: "branchdelivery",
        meta: {
          keepAlive: false,
        },
        component: () => import("../views/Zhixian/branchdelivery.vue"),
      },
      //锦上宅物流结算表
      {
        path: "/jinshangMansionList",
        name: "jinshangMansionList",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/jinshangMansion/jinshangMansionList.vue"),
      },
      //五金物流结算表
      {
        path: "/metals",
        name: "metals",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shouye/metals.vue"),
      },
      //五金发货单承运计划
      {
        path: "/hardware",
        name: "hardware",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/Shouye/hardware.vue"),
      },
      // 中心仓总览
      {
        path: "/soverview",
        name: "soverview",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/soverview.vue"),
      },
      // 订单耗时统计表
      {
        path: "/orderTimeTable",
        name: "orderTimeTable",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/orderTimeTable.vue"),
      },
      // 中心仓库存 齐
      {
        path: "/sallStock",
        name: "sallStock",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/sallStock.vue"),
      },
      // 中心仓库存 不齐
      {
        path: "/spartStock",
        name: "spartStock",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/spartStock .vue"),
      },
      // 中心仓运单管理 -换成生产厂的运单管理 不加标识
      {
        path: "/swaybill",
        name: "swaybill",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/swaybill.vue"),
      },
      // 中转仓承运计划
      {
        path: "/splan",
        name: "splan",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/splan.vue"),
      },
      // 中转仓自提/快递清单
      {
        path: "/courier",
        name: "courier",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/courier.vue"),
      },
      // 中心仓结算表
      {
        path: "/centerPayoff",
        name: "centerPayoff",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/CenterStore/centerPayoff.vue"),
      },

    ],
  },
];

const router = new VueRouter({
  model: "history",
  routes,
});

export default router;
